export default __webpack_public_path__ + "static/media/266.ee9a9903.jpg";